// extracted by mini-css-extract-plugin
export default {"chart":"LactateChart_chart__UDIIp","avgMinMaxContainer":"LactateChart_avgMinMaxContainer__0KKEe","avgMinMax":"LactateChart_avgMinMax__F9bhc","button":"LactateChart_button__BWv1d"};